<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <input #titleInput type="text" placeholder="Task Title" [formControlName]="'title'" [focus]="true" (keydown.esc)="onClose()" checkTouch>
  <help-block [control]="form.get('title')" [messages]="{'maxlength': 'Maximum length of 1024 symbols is exceed'}"></help-block>
  <button a-button type="submit" class="btn btn_primary" [pending]="pending$ | async">Add</button>
  <button a-button type="button" class="btn btn_text" (click)="onClose()">Cancel</button>
</form>
